import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#CAAA2D",
  "fill-rule": "evenodd",
  d: "M12 20a8 8 0 1 0 0-16 8 8 0 0 0 0 16m4.105-9.76a.857.857 0 0 0-1.353-1.052l-3.466 4.457-2.179-1.743a.857.857 0 1 0-1.07 1.339l2.856 2.286a.857.857 0 0 0 1.212-.144z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "checkmark-circle"}) } }